import { UseFormReturn } from 'react-hook-form';
import { IuserInfo } from 'reducer/common/userInfo';
import { IlogRecordQuery } from 'view/Layout/Project/components/LogRecordModal/type';
import {
  IretailerSetupRtn,
  RtnQueryForm,
  RtnQueryFormDetail,
} from '../../init';

export interface ResultSecionProps {
  _logRecordData: [
    IlogRecordQuery[],
    React.Dispatch<React.SetStateAction<IlogRecordQuery[]>>,
  ];

  _retailerSetup: [
    IretailerSetupRtn,
    React.Dispatch<React.SetStateAction<IretailerSetupRtn>>,
  ];
  _showLogRecordModal: [boolean, React.Dispatch<React.SetStateAction<boolean>>];

  formReturnDetail: UseFormReturn<RtnQueryFormDetail>;
  userInfoReducer: IuserInfo;
  handleSearch: (
    page?: number,
    pageSize?: number,
    doLoading?: boolean,
  ) => (input: RtnQueryForm | RtnQueryFormDetail) => Promise<void>;
}

export interface IlogRecordQueryRequest {
  retailerId: string;
  actionType: string;
  docType: string;
  docNo: string;
  docSeqNo: string;
}
export interface IlogRecordQueryResponse {
  contents: IlogRecordQuery[];
}
export interface IreturnsDownloadPreviewRequest {
  retailerId: string;
  returnSeqNos: string[];
  rptType: string;
  sort: {
    desc: string;
    property: string;
  }[];
  previewShowPrice: boolean;
  downloadShowPrice: boolean;
}

export enum ReturnsDownloadPreviewRequest {
  rptType = 'rptType',
  retailerId = 'retailerId',
  returnSeqNos = 'returnSeqNos',
  sort = 'sort',
  previewShowPrice = 'previewShowPrice',
  downloadShowPrice = 'downloadShowPrice',
}
